import axios from 'axios'

const itoviDomain = 'beta.api.itovi.com';
// const itoviDomain = 'api.staging.itovi.com'; // for testing
// const itoviDomain = 'localhost:4000'; // for testing
const itoviBaseUrl = `https://${itoviDomain}/v3`;

// a variable for storing all the GET requests that are in-progress
// so we can efficiently handle multiple requests (identical requests
// return simply the first request made if the first is still in-progress)
const inProgressGetRequests = {};
export default {
  axios: axios.create({
    baseURL: itoviBaseUrl
  }),
  get(url, config) {
    // if a GET request is made while an identical GET request is still in-progress,
    // just return the first
    if (inProgressGetRequests[url] == null) { inProgressGetRequests[url] = this.axios.get(url, config) }
    inProgressGetRequests[url].then(() => { inProgressGetRequests[url] = null });
    return inProgressGetRequests[url]
  },
  post(url, data, config) {
    return this.axios.post(url, data, config)
  },
  patch(url, data, config) {
    return this.axios.patch(url, data, config)
  },
  put(url, data, config) {
    return this.axios.put(url, data, config)
  },
  delete(url, data, config) {
    return this.axios.delete(url, config)
  },
}

// export default () => {
//   let itoviDomain = 'staging.api.itovi.com'
//   let itoviBaseUrl = `https://${itoviDomain}/v1`
//   return axios.create({
//     baseURL: itoviBaseUrl
//   })
// }
